import { Line, mixins } from "vue-chartjs"

export default Line.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        }
    },
    computed: {
        options () {
            return {
                tooltips: {
                    mode: "index"
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            fontColor: "#00274F"
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            display: false,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }]
                },
                legend: {
                    display: true,
                    position: "right",
                    labels: {
                        fontSize: 11,
                        // fontFamily: "'Helvetica Neue', Helvetica, Arial, 'sans-serif'",
                        fontStyle: "bold",
                        fontColor: "#00274F",
                        boxWidth: 14,
                        padding: 13
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                annotation: {
                    drawTime: "afterDatasetsDraw",
                    annotations: []
                }
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
